module.exports = __webpack_public_path__ + "media/old_images/app-btn-app-store-40d8cf25.png";